import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
import axios from 'axios';
import DataConfig from './_config.json'
import { parseJwt } from './parseJWT';  // ← ใช้ parseJwt ที่มีอยู่แล้ว
var onLoading = require('./_source/onload.js');

require('./_css/getjson.css');

// Helper functions to get fresh values from localStorage
const getToken = () => localStorage.getItem('Token');
const getCompany = () => localStorage.getItem("company");
const getHostAPI = () => {
    const company = getCompany();
    return DataConfig[company + "hostname"];
};
const getAPIKey = () => {
    const company = getCompany();
    return DataConfig["API_KEY"][company];
};

// Helper function to check if token is expired (4 hours validity)
const isTokenExpired = () => {
    const token = getToken();
    if (!token || token === 'null' || token === 'undefined') {
        return true; // No token = considered expired
    }
    
    const decoded = parseJwt(token);
    if (!decoded || !decoded.exp) {
        return false; // Can't decode = assume not expired (let backend decide)
    }
    
    const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
    const isExpired = decoded.exp < currentTime;
    
    if (isExpired) {
        console.warn('🕐 Token expired at:', new Date(decoded.exp * 1000).toLocaleString());
        console.warn('🕐 Current time:', new Date().toLocaleString());
    }
    
    return isExpired;
};

// Helper function to check if endpoint is whitelisted (401 might be permission issue, not token expiry)
const isWhitelistedEndpoint = (url) => {
    return url?.includes('reportmanage/category') || 
           url?.includes('reportmanage/optionreport');
};

// Helper function to check if 401 error is due to token expiry
const isTokenExpiredError = (error) => {
    if (!error.response || error.response.status !== 401) return false;
    
    // First check: Is token actually expired?
    if (isTokenExpired()) {
        return true; // Token expired by time
    }
    
    // Second check: Does error message indicate expiry?
    const data = error.response?.data;
    return data?.message?.includes('expired') ||
           data?.message?.includes('invalid') ||
           data?.error?.includes('expired') ||
           data?.error?.includes('token');
};

// Helper function to handle 401 errors
const handle401Error = (error, url) => {
    console.warn('🔒 401 Unauthorized');
    console.warn('📍 Request URL:', url);
    console.warn('📍 Error message:', error.response?.data);
    
    const isWhitelisted = isWhitelistedEndpoint(url);
    const isExpired = isTokenExpiredError(error);
    
    if (isExpired && !isWhitelisted) {
        console.warn('🔄 Token expired - Clearing token and redirecting to login');
        localStorage.removeItem('Token');
        
        if (window.location.pathname !== '/' && window.location.pathname !== '/login') {
            window.location.href = '/login';
        }
    } else if (isWhitelisted) {
        console.warn('⚠️ 401 from whitelisted endpoint - keeping token (may be permission issue)');
    } else {
        console.warn('⚠️ 401 but not confirmed as token expiry - keeping token for now');
    }
};



export const INSCorServicePostTest = (url, Parameter, id) => {
    onLoading.onLoading("Y");
    var urlPostTest = url +/*  "&api_key=" + getAPIKey() +  */"&jwt=" + getToken();
    let res = postDatatodb(urlPostTest, Parameter)
    // console.log(res);
    let resreturn
    if (res !== 'error') {
        onLoading.onLoading("N");
        resreturn = res
    }
    return resreturn
}

export const INSCorServicePost = (url, Parameter, id) => {
    onLoading.onLoading("Y");
    // var data ="...";
    var urlServicePost = getHostAPI() + url + "&api_key=" + getAPIKey() + "&jwt=" + getToken();
    // console.log(urlServicePost);
    let res = postDatatodb(urlServicePost, Parameter)
    // console.log(res);
    if (res) {
        onLoading.onLoading("N");
    }
    return res
}
export const GetCorService = async (url) => {
    onLoading.onLoading("Y");
    // console.log(url);
    var urlCorService = getHostAPI() + url + "&api_key=" + getAPIKey() + "&jwt=" + getToken();
    // console.log(urlCorService);
    let res = await getDataindb(urlCorService)
    /* console.log(res.data[0].CODE ,"==",res.data[0].MYNAMETH); */
    if (res !== "error") {
        await onLoading.onLoading("N");
    }
    return res
}

export const GetCorServicei = (url, id) => {
    var Old_HTML = ""
    if (document.getElementById(id)) {
        Old_HTML = document.getElementById(id).innerHTML;
        document.getElementById(id).innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
    }
    var urlCorServicei = getHostAPI() + url + "&api_key=" + getAPIKey() + "&jwt=" + getToken();
    // console.log("urlCorServicei", urlCorServicei);
    let res = getDataindb(urlCorServicei)
    if (res) {
        if (document.getElementById(id)) { document.getElementById(id).innerHTML = Old_HTML; }
    }
    return res
}

export const OnGetJson = (url) => {
    /* console.log("OnGetJson"); */
    onLoading.onLoading("Y");
    var urlOnGetJson = getHostAPI() + url + "&api_key=" + getAPIKey() + "&jwt=" + getToken();
    // console.log(urlOnGetJson);
    let res = getDataindb(urlOnGetJson)
    if (res) {
        onLoading.onLoading("N");
    }
    return res;
}

export const OnGetJsoni = (url, id) => {
    document.getElementById(id).innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
    var urlOnGetJsoni = getHostAPI() + url + "&api_key=" + getAPIKey() + "&jwt=" + getToken();
    // console.log(urlOnGetJsoni);
    // console.log(url, id);
    let res = getDataindb(urlOnGetJsoni)
    if (res) {
        document.getElementById(id).innerHTML = "";
    }
    return res;
}
export default class Loadding extends Component {
    render() {
        return (
            <div></div>
        )
    }
}
//--------------------------------------------------------------------------------
export async function getDataindb(urlapi) {
    // Check if token is expired before making request
    if (isTokenExpired()) {
        console.warn('⏰ Token expired - redirecting to login before API call');
        localStorage.removeItem('Token');
        if (window.location.pathname !== '/' && window.location.pathname !== '/login') {
            window.location.href = '/login';
        }
        return "error";
    }
    
    try {
        let result = await axios.get(urlapi)
        return result
    } catch (error) {
        // Handle 401 errors specifically
        if (error.response && error.response.status === 401) {
            handle401Error(error, urlapi);
        }
        return "error"
    }
}

export async function postDatatodb(urlapi, parameter) {
    // Check if token is expired before making request
    if (isTokenExpired()) {
        console.warn('⏰ Token expired - redirecting to login before API call');
        localStorage.removeItem('Token');
        if (window.location.pathname !== '/' && window.location.pathname !== '/login') {
            window.location.href = '/login';
        }
        return "error";
    }
    
    try {
        let result = await axios.post(urlapi, parameter)
        return result
    } catch (error) {
        // Handle 401 errors specifically
        if (error.response && error.response.status === 401) {
            handle401Error(error, urlapi);
        }
        return "error"
    }
}
//----------------------------------------------------------------------------------
const hostname = window.location.hostname
// Example
// var url = "CSMAXDOC/MAXDOC?tablename=CSSTKISSUE&code=" + CODE;
// console.log(genURL(url));
// await axios.get(genURL(url), { timeout: 3600 }).then(res => {}
export const genURL = (url) => {
    const token = getToken();
    const apiKey = getAPIKey();
    const hostAPI = getHostAPI();
    
    // Debug: log if token is missing
    if (!token || token === 'null' || token === 'undefined') {
        console.error('❌ genURL: Token is missing or invalid! Cannot generate URL.');
        console.error('📍 Token value:', token);
        console.error('📍 localStorage Token:', localStorage.getItem('Token'));
        console.error('📍 Requested URL:', url);
        console.error('⚠️ This will cause 401 Unauthorized error!');
        // ยังคง return URL แต่ไม่มี jwt parameter เพื่อให้ backend ตอบ 401 ชัดเจน
        // แทนที่จะส่ง &jwt=null ซึ่งทำให้สับสน
    }
    
    return hostAPI + url + "&api_key=" + apiKey + (token && token !== 'null' && token !== 'undefined' ? "&jwt=" + token : "");
}
// Example
// var url = "CSMAXDOC/MAXDOC?tablename=CSSTKISSUE&code=" + CODE;
// console.log(genURL(url));
// await axios.get(genURL(url), { timeout: 3600 }).then(res => {}
export const gengetURLTEST = (url) => {
    let url1 = url.split("/")
    // return "http://Localhost:8080/" + url1[1] + "&jwt=" + getToken();
    return "http://" + hostname + ":8080/" + url1[1] + "&jwt=" + getToken();
}
// Example
// let url = "CSSTKISSUE/Save?";
// await  axios.post(genpostURL(url), parameter).then(res => {}
export const genpostURL = (url) => {
    const token = getToken();
    const apiKey = getAPIKey();
    const hostAPI = getHostAPI();
    
    if (!token || token === 'null' || token === 'undefined') {
        console.error('❌ genpostURL: Token is missing or invalid!');
        console.error('📍 Requested URL:', url);
    }
    
    return hostAPI + url + "&api_key=" + apiKey + (token && token !== 'null' && token !== 'undefined' ? "&jwt=" + token : "");
}
// Example
// let url = "CSSTKISSUE/Save?";
// await  axios.post(genpostURL(url), parameter).then(res => {}
export const genpostURLTEST = (url) => {
    // let urlnew = url.split("/")
    // return "http://Localhost:8080/" + urlnew[1] + "&jwt=" + getToken();
    return "http://" + hostname + ":8080" + url + "&jwt=" + getToken();
}

export const genURLTEST = (url) => {
    // let urlnew = url.split("/")
    // return "http://Localhost:8080/" + urlnew[1] + "&jwt=" + getToken(); 
    return `http://${hostname}:8080/${url}&jwt=` + getToken();

}

// URL สำหรับ endpoint ที่ไม่ต้องการ JWT authentication
// ใช้เฉพาะกับ public endpoints หรือ endpoints ที่ไม่ต้องการ token
export const genURLPublic = (url) => {
    const apiKey = getAPIKey();
    const hostAPI = getHostAPI();
    console.log('🌐 genURLPublic called for:', url);
    return hostAPI + url + "&api_key=" + apiKey;
}

//================================================================================
// 🆕 มาตรฐานใหม่: ส่ง Token ผ่าน Authorization Header (Best Practice)
//================================================================================

/**
 * ✅ สร้าง Axios Config พร้อม Authorization Header
 * @returns {Object} Axios config object with headers
 */
const createAuthConfig = () => {
    const token = getToken();
    
    // 🔍 Debug logging
    console.log('🔑 createAuthConfig called');
    console.log('📦 Token from localStorage:', token ? `EXISTS (${token.length} chars)` : 'MISSING');
    console.log('📦 Token value:', token);
    
    if (!token || token === 'null' || token === 'undefined') {
        console.warn('⚠️ createAuthConfig: Token is missing or invalid!');
        console.warn('⚠️ Will NOT send Authorization Header');
        return {
            headers: {
                'Content-Type': 'application/json'
            }
        };
    }
    
    const authHeader = `Bearer ${token}`;
    console.log('✅ createAuthConfig: Will send Authorization Header');
    console.log('📤 Authorization Header:', authHeader.substring(0, 50) + '...');
    
    return {
        headers: {
            'Authorization': authHeader,
            'Content-Type': 'application/json'
        }
    };
};

/**
 * ✅ GET Request with Bearer Token Authentication
 * Sends JWT token via Authorization Header (not query string)
 * @param {string} urlapi - Full URL to API endpoint
 * @returns {Promise} Axios response or "error"
 */
export async function getDataWithAuth(urlapi, retryCount = 0) {
    // Check if token is expired before making request
    if (isTokenExpired()) {
        console.warn('⏰ Token expired - redirecting to login before API call');
        localStorage.removeItem('Token');
        if (window.location.pathname !== '/' && window.location.pathname !== '/login') {
            window.location.href = '/login';
        }
        return "error";
    }
    
    try {
        const config = createAuthConfig();
        console.log('🔍 GET WithAuth:', urlapi);
        console.log('🔑 Using Authorization Header:', !!config.headers.Authorization);
        
        let result = await axios.get(urlapi, config);
        return result;
    } catch (error) {
        // If there's no response object it's likely a network/CORS/connection error
        if (!error.response) {
            console.warn('❌ getDataWithAuth Network Error for URL:', urlapi);
            console.warn('📍 Error message:', error.message);
            console.warn('💡 Possible causes: backend server not running, wrong host/API config, or CORS issues.');
            return "error";
        }

        console.error('❌ getDataWithAuth Error:', error.message || error);
        console.error('📍 Response:', error.response?.data);
        console.error('📍 Status:', error.response?.status);

        // 🔄 Handle 401 with automatic retry (max 1 retry)
        if (error.response && error.response.status === 401) {
            if (retryCount === 0) {
                console.warn('⚠️ 401 on first attempt - retrying once (possible CORS preflight issue)...');
                // Wait 100ms and retry
                await new Promise(resolve => setTimeout(resolve, 100));
                return getDataWithAuth(urlapi, retryCount + 1);
            }

            // If retry also failed, handle as normal 401
            handle401Error(error, urlapi);
        }

        return "error";
    }
}

/**
 * ✅ POST Request with Bearer Token Authentication
 * Sends JWT token via Authorization Header (not query string)
 * @param {string} urlapi - Full URL to API endpoint
 * @param {Object} parameter - Request body
 * @returns {Promise} Axios response or "error"
 */
export async function postDataWithAuth(urlapi, parameter, retryCount = 0) {
    // Check if token is expired before making request
    if (isTokenExpired()) {
        console.warn('⏰ Token expired - redirecting to login before API call');
        localStorage.removeItem('Token');
        if (window.location.pathname !== '/' && window.location.pathname !== '/login') {
            window.location.href = '/login';
        }
        return "error";
    }
    
    try {
        const config = createAuthConfig();
        console.log('🔍 POST WithAuth:', urlapi);
        console.log('🔑 Using Authorization Header:', !!config.headers.Authorization);
        
        let result = await axios.post(urlapi, parameter, config);
        return result;
    } catch (error) {
        console.error('❌ postDataWithAuth Error:', error);
        console.error('📍 Response:', error.response?.data);
        console.error('📍 Status:', error.response?.status);
        
        // 🔄 Handle 401 with automatic retry (max 1 retry)
        if (error.response && error.response.status === 401) {
            if (retryCount === 0) {
                console.warn('⚠️ 401 on first attempt - retrying once (possible CORS preflight issue)...');
                // Wait 100ms and retry
                await new Promise(resolve => setTimeout(resolve, 100));
                return postDataWithAuth(urlapi, parameter, retryCount + 1);
            }
            
            // If retry also failed, handle as normal 401
            handle401Error(error, urlapi);
        }
        return "error";
    }
}

/**
 * ✅ Generate API URL for requests with Bearer Token Authentication
 * Token will be sent via Authorization Header (not in query string)
 * @param {string} url - Relative URL path
 * @returns {string} Full URL without JWT in query string
 */
export const genURLWithAuth = (url) => {
    const apiKey = getAPIKey();
    const hostAPI = getHostAPI();
    const token = getToken();
    
    // Debug: log if token is missing
    if (!token || token === 'null' || token === 'undefined') {
        console.error('❌ genURLWithAuth: Token is missing or invalid!');
        console.error('📍 Token value:', token);
        console.error('📍 Requested URL:', url);
        console.error('⚠️ This will cause 401 Unauthorized error!');
    }
    
    // ส่ง JWT ผ่าน Authorization Header เท่านั้น (ไม่ส่งใน URL)
    // Backend รองรับ Authorization Header แล้ว (ดู tokenExtractor.go)
    return hostAPI + url + "&api_key=" + apiKey;
}

/**
 * ✅ Generate POST API URL for requests with Bearer Token Authentication
 * Token will be sent via Authorization Header (not in query string)
 * @param {string} url - Relative URL path
 * @returns {string} Full URL without JWT in query string
 */
export const genPostURLWithAuth = (url) => {
    const apiKey = getAPIKey();
    const hostAPI = getHostAPI();
    const token = getToken();
    
    if (!token || token === 'null' || token === 'undefined') {
        console.error('❌ genPostURLWithAuth: Token is missing or invalid!');
    }
    
    // ส่ง JWT ผ่าน Authorization Header เท่านั้น (ไม่ส่งใน URL)
    return hostAPI + url + "&api_key=" + apiKey;
}

/**
 * ✅ GetCorService with Bearer Token Authentication
 * Sends JWT token via Authorization Header (not query string)
 * @param {string} url - Relative URL path
 * @returns {Promise} API response
 */
export const GetCorServiceWithAuth = async (url) => {
    onLoading.onLoading("Y");
    const urlCorService = genURLWithAuth(url);
    console.log('🔍 GetCorServiceWithAuth:', urlCorService);
    
    let res = await getDataWithAuth(urlCorService);
    
    if (res !== "error") {
        await onLoading.onLoading("N");
    }
    return res;
}

/**
 * ✅ Insert/Save Data with Bearer Token Authentication
 * Sends JWT token via Authorization Header (not query string)
 * @param {string} url - Relative URL path
 * @param {Object} Parameter - Request body
 * @param {string} id - Element ID (optional)
 * @returns {Promise} API response
 */
export const InsertCorServicePostWithAuth = (url, Parameter, id) => {
    onLoading.onLoading("Y");
    const urlServicePost = genPostURLWithAuth(url);
    console.log('🔍 InsertCorServicePostWithAuth:', urlServicePost);
    
    let res = postDataWithAuth(urlServicePost, Parameter);
    
    if (res) {
        onLoading.onLoading("N");
    }
    return res;
}

/**
 * ✅ Fetch JSON Data with Bearer Token Authentication
 * Sends JWT token via Authorization Header (not query string)
 * @param {string} url - Relative URL path
 * @returns {Promise} API response
 */
export const OnGetJsonWithAuth = (url) => {
    onLoading.onLoading("Y");
    const urlOnGetJson = genURLWithAuth(url);
    console.log('🔍 OnGetJsonWithAuth:', urlOnGetJson);
    
    let res = getDataWithAuth(urlOnGetJson);
    
    if (res) {
        onLoading.onLoading("N");
    }
    return res;
}

//================================================================================
// 📌 หมายเหตุ: วิธีการใช้งาน
//================================================================================
// 
// ❌ แบบเดิม (Query String) - ไม่แนะนำ:
// import { GetCorService, INSCorServicePost } from './_getjson';
// let result = await GetCorService('endpoint?param=value');
//
// ✅ แบบใหม่ (Authorization Header) - แนะนำ:
// import { GetCorServiceWithAuth, InsertCorServicePostWithAuth } from './_getjson';
// let result = await GetCorServiceWithAuth('endpoint?param=value');
//
// ✅ หรือใช้ตรงๆ:
// import { getDataWithAuth, genURLWithAuth } from './_getjson';
// const url = genURLWithAuth('endpoint?param=value');
// const result = await getDataWithAuth(url);
//
//================================================================================
